import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MDBModalRef, MDBModalService } from "angular-bootstrap-md";
import { ModalChoiceComponent } from "../modals/modal-choice/modal-choice.component";
import { ModalFormAnswerListComponent } from "../modals/modal-form-answer-list/modal-form-answer-list.component";
import { ModalFormAnswerComponent } from "../modals/modal-form-answer/modal-form-answer.component";
import { ModalFormCreateComponent } from "../modals/modal-form-create/modal-form-create.component";
import { ModalFormDetailComponent } from "../modals/modal-form-detail/modal-form-detail.component";
import { ModalFormFillComponent } from "../modals/modal-form-fill/modal-form-fill.component";
import { ModalFormPermissionsComponent } from "../modals/modal-form-permissions/modal-form-permissions.component";
import { ModalMessageComponent } from "../modals/modal-message/modal-message.component";
import { CompanyService } from "../service/company.service";
import { MatSort } from "@angular/material/sort";
import { ModalFormModelListComponent } from "../modals/modal-form-model-list/modal-form-model-list.component";
import { ActivatedRoute, Router } from "@angular/router";
import { EmailTemplateService } from "../service/emailtemplate.service";
import { ModalEmailTemplateCreateComponent } from "../modals/modal-email-template-create/modal-email-template-create.component";
import { ModalEmailTemplateSendComponent } from "../modals/modal-email-template-send/modal-email-template-send.component";

@Component({
  selector: "app-emails-config",
  templateUrl: "./emails-config.component.html",
  styleUrls: ["./emails-config.component.css"],
})
export class EmailsConfigComponent implements OnInit {
  constructor(
    private emailTemplateService: EmailTemplateService,
    private modalService: MDBModalService,
    private route: ActivatedRoute,
    private companyService: CompanyService,

    private router: Router
  ) {}
  company_type = localStorage.getItem("companyType");

  modalRef: MDBModalRef;

  is_loaded: boolean = false;

  /* pagination related variabels */
  page: number = 1;
  count_total: number = 0;
  page_count1: number = 0;
  page_count2: number = 0;
  page_size = 10;

  send_email_birthday = false;
  ngOnInit(): void {
    this.settings();
  }

  truncateString(str, max) {
    return str.length > max ? str.substr(0, max - 1) + "…" : str;
  }

  settings() {
    const x = localStorage.getItem("company_settings");
    if (x) {
      const data = JSON.parse(x);
      this.send_email_birthday = data.send_email_birthday;
      this.is_loaded = true;
    }
  }

  error(error, string) {
    var msg = "";
    if (
      error.error != null &&
      error.error.error != null &&
      error.error.error.length < 50
    )
      msg = error.error.error;
    else msg = "Por favor verifique as informações inseridas";
    this.openMessage(`Erro, não foi possível ${string} o médico.`, msg, false);
  }

  openMessage(title, text, bgclick: boolean) {
    this.modalRef = this.modalService.show(ModalMessageComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: bgclick,
      class: "modal-dialog-centered modal-dialog",
      containerClass: "",
      animated: false,
      data: {
        title: title,
        text: text,
      },
    });
  }

  onChange() {
    console.log(this.send_email_birthday);
    this.companyService.updateEmailCompanyBirthday().subscribe((data) => {
      localStorage.setItem("company_settings", JSON.stringify(data));
    });
  }
}
